import * as React from 'react';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import NotificationModel, { NotificationType } from '../../application/core/Notification';
import NotificationConsumed from '../../application/core/events/NotificationConsumed';
import close from './close.svg';

interface Props {
    notification: NotificationModel;
}

class Notification extends React.PureComponent<Props & DispatchProps> {
    constructor(props: Props & DispatchProps) {
        super(props);
        if (!this.props.notification.data.hasButton) {
            setTimeout(() => {
                this.props.dispatch(new NotificationConsumed(this.props.notification.id));
            }, 3000);
        }
    }

    public render(): JSX.Element {
        const notificationClass = `notification ${
            NotificationType[
                this.props.notification.data.notificationType === undefined
                    ? NotificationType.Error
                    : this.props.notification.data.notificationType
            ]
        } ${this.props.notification.data.hasButton && 'withCloseBtn'}`;
        return (
            <div className={notificationClass}>
                <div className="notification-text">{this.props.notification.data.message}</div>
                {this.props.notification.data.hasButton && (
                    <div className="close-notification" onClick={this.closeNotification}>
                        <img src={close} />
                    </div>
                )}
            </div>
        );
    }

    private closeNotification = (): void => {
        this.props.dispatch(new NotificationConsumed(this.props.notification.id));
    };
}

export default connect(mapDispatchToProps)(Notification);



// WEBPACK FOOTER //
// ./src/view/notifications/Notification.tsx